<template>
  <transition name="fade-slide">
    <div
      v-show="showScrollButton"
      class="scroll-to-top"
      @click="scrollToTop"
      title="返回顶部"
    >
      <i class="fas fa-chevron-up"></i>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
const showScrollButton = ref(false);

// 滚动处理函数
const handleScroll = () => {
  showScrollButton.value = window.pageYOffset > 300; // 当滚动超过 300px 时显示按钮
};

// 返回顶部功能
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

// 组件挂载后添加事件监听
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  handleScroll();
});

// 组件卸载前移除事件监听
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.scroll-to-top {
  cursor: pointer;
  position: fixed;
  bottom: 60px;
  right: 30px;
  z-index: 300;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-color, #108ee9);
  color: white;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(16, 142, 233, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.scroll-to-top:hover {
  background-color: #0c7ac9;
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 8px 20px rgba(16, 142, 233, 0.4);
}

.scroll-to-top:active {
  transform: translateY(-2px) scale(0.95);
}

/* 进入和离开的过渡动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.8);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .scroll-to-top {
    width: 40px;
    height: 40px;
    bottom: 40px;
    right: 20px;
    font-size: 16px;
  }
}
</style>